<div class="searchable-select" [class.is-open]="isOpen" [class.is-disabled]="disabled">
  <div class="input-wrap" #inputWrap>
    <input
      class="searchable-input"
      nbInput
      fullWidth
      type="text"
      [placeholder]="placeholder"
      [value]="displayText"
      readonly
      [disabled]="disabled"
      (click)="toggleDropdown($event)" />

    <nb-icon
      class="toggle-icon"
      [icon]="isOpen ? 'chevron-up-outline' : 'chevron-down-outline'">
    </nb-icon>
  </div>

  <div
    class="options-panel"
    [class.is-open-above]="isOpenAbove"
    *ngIf="isOpen && !disabled"
    [ngStyle]="panelStyle"
    (click)="$event.stopPropagation()">

    <div class="search-box">
      <input
        #searchInput
        class="dropdown-search-input"
        nbInput
        fullWidth
        type="text"
        [placeholder]="placeholder"
        [value]="searchText"
        (input)="onSearchInput($event)"
        (click)="$event.stopPropagation()" />
    </div>

    <button
      type="button"
      class="option-item"
      [class.is-selected]="isOptionSelected(option)"
      *ngFor="let option of filteredOptions"
      (mousedown)="selectOption(option, $event)">
      <span class="option-check" *ngIf="multiple">
        {{ isOptionSelected(option) ? '✓' : '' }}
      </span>
      <span>{{ getOptionLabel(option) }}</span>
    </button>

    <div class="no-results" *ngIf="!filteredOptions.length">
      {{ noResultsText }}
    </div>
  </div>
</div>
